/**
 * Created by Pradeep Kumar on 5/24/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TweenLite} from "gsap";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";

export class TombOfNefertitiFreeSpinOutroController extends FreespinOutroController {

    public start(): void {
        // #403
        const totalWin: number = this._serverData!.totalWin,
            totalWinBelowStake: boolean = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (totalWin <= (this._serverData as TombOfNefertitiParsedGameData).playedBetValue)),
            delay: number = (!totalWinBelowStake && totalWin > 0) ? 2.7 : 0; // to compensate the count up time of total bonus win amount

        TweenLite.to(() => {}, delay, {
            onComplete : () => {
                super.start();
            }
        });
    }

    protected close():void {
        super.close();

        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : GameMode.NORMAL}));

        // switch to main game ambiance sound
        SlotGame.sound.fadeAmbience(1, 200);
        SlotGame.sound.playAmbience(TombOfNefertitiSoundConfig.instance.MAIN_GAME_AMBIANCE);

        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_INTRO_PAPER_CLOSE);
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return (data.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN || data.mode === GameMode.FREESPIN) && data.freespinsLeft === 0;
    }
}